import { Routes, Route, Navigate, useParams } from 'react-router-dom'

function BlogPostRedirect() {
  const { slug } = useParams<{ slug: string }>()
  return <Navigate to={`/news/${slug}`} replace />
}
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Careers from './pages/Careers'
import NewsList from './pages/NewsList'
import NewsPost from './pages/NewsPost'
import Contact from './pages/Contact'
import Location from './pages/Location'
import Sector from './pages/Sector'
import NotFound from './pages/NotFound'

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        {/* Redirects from old /blog URLs */}
        <Route path="/blog" element={<Navigate to="/news" replace />} />
        <Route path="/blog/:slug" element={<BlogPostRedirect />} />
        
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/news" element={<NewsList />} />
        <Route path="/news/:slug" element={<NewsPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gb/london" element={<Location locationKey="london" />} />
        <Route path="/gb/cheltenham" element={<Location locationKey="cheltenham" />} />
        <Route path="/gb/bristol" element={<Location locationKey="bristol" />} />
        <Route path="/uae/dubai" element={<Location locationKey="dubai" />} />
        <Route path="/uae/abu-dhabi" element={<Location locationKey="abu-dhabi" />} />
        
        {/* Sector Routes */}
        <Route path="/sectors/healthcare" element={<Sector sectorKey="healthcare" />} />
        <Route path="/sectors/fintech" element={<Sector sectorKey="fintech" />} />
        <Route path="/sectors/cyber" element={<Sector sectorKey="cyber" />} />
        <Route path="/sectors/media" element={<Sector sectorKey="media" />} />
        <Route path="/sectors/ecommerce" element={<Sector sectorKey="ecommerce" />} />
        <Route path="/sectors/saas" element={<Sector sectorKey="saas" />} />
        <Route path="/sectors/ai" element={<Sector sectorKey="ai" />} />
        <Route path="/sectors/cleantech" element={<Sector sectorKey="cleantech" />} />
        <Route path="/sectors/edtech" element={<Sector sectorKey="edtech" />} />
        <Route path="/sectors/property" element={<Sector sectorKey="property" />} />
        <Route path="/sectors/legal" element={<Sector sectorKey="legal" />} />
        <Route path="/sectors/logistics" element={<Sector sectorKey="logistics" />} />
        
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  )
}

export default App
